import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {LoadingPage} from 'shells/loading-page/loading-page';

import type {PreferenceCenterAudience as Audience} from 'nutshell-graphql-types';

import {Header} from '../../email-marketing-unsubscribe/header';
import {PreferenceCenter} from '../../email-marketing-unsubscribe/preference-center';
import {UpdatePreferences} from '../../email-marketing-unsubscribe/update-preferences';

import styles from './preference-center-preview.module.css';

type Props = {
    audiences: Audience[];
    isLoading: boolean;
};

export function PreferenceCenterPreview(props: Props) {
    const publicAudiences = props.audiences.map((audience) => ({
        id: audience.id,
        name: audience.publicName,
        description: audience.publicDescription || '',
        isSubscribed: false,
    }));

    return (
        <div className='background-offwhite full-width full-height flex flex-dir-col align-center overflow-auto'>
            {props.isLoading ? (
                <LoadingPage />
            ) : (
                <div className={styles.container}>
                    <StackLegacy spacing={16}>
                        <Header emailAddress='[your recipient’s email address]' />
                        {publicAudiences.length > 0 ? (
                            <PreferenceCenter
                                publicAudiences={publicAudiences}
                                onSuccessfulUnsubscribe={() => {}}
                            />
                        ) : (
                            <UpdatePreferences
                                // @ts-expect-error
                                emailAddress='[your recipient’s email address]'
                                allowAudienceUnsubscribe={false}
                                isGeneric={true}
                            />
                        )}
                    </StackLegacy>
                </div>
            )}
        </div>
    );
}
